module.exports = __webpack_public_path__ + "static/img/4.ddbd980.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/eng/4.png
// module id = A6Hp
// module chunks = 0